import React, {useEffect, useState} from 'react';
import {KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import {Button, Card, Col, Divider, message, Modal, Row, Space, Tag} from 'antd';
import Flex from '../../../components/Flex';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import UseKnowledgeSubmission, {IKnowledgeSubmission, IKnowledgeSubmissionQuestion} from '../../../hooks/apis/useKnowledgeSubmission';
import KnowledgeQuestionSubmitItem from '../../../components/KnowledgeQuestion/SubmitItem';
import Countdown from 'antd/lib/statistic/Countdown';
import {KnowledgeQuestionType} from '../../../hooks/apis/useKnowledgeBank';
import QuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useParams} from 'react-router-dom';
import useQuickRouter from '../../../utils/QuickRouter';
const {confirm} = Modal;

export default function KnowledgeSubmissionSubmitPage() {
  const auth = useAuth();
  const querySubmissionState = UseKnowledgeSubmission.queryById();
  const submitQuestionState = UseKnowledgeSubmission.submitQuestion();
  const submitState = UseKnowledgeSubmission.submit();
  const params = useParams() as {id?: string};
  const submissionId = parseInt(params?.id || '');
  const [submission, setSubmission] = useState<IKnowledgeSubmission>();
  const questions = submission ? submission.knowledgeSubmissionQuestions : [];
  const [currentQuestion, setCurrentQuestion] = useState<IKnowledgeSubmissionQuestion>();
  const [isShowAll, setIsShowAll] = useState(false);
  const quickRouter = useQuickRouter();

  function refresh() {
    querySubmissionState
      .request({id: submissionId})
      .then(res => {
        setSubmission(res);
        setCurrentQuestion(res.knowledgeSubmissionQuestions[0]);
      })
      .catch(CommonApiErrorHandler);
  }

  async function submitCurrentQuestion() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    return await submitQuestionState.request({
      id: submissionId,
      submissionQuestionId: currentQuestion.id,
      choices: currentQuestion.choices,
    });
  }

  async function nextQuestion() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    try {
      const newSubmission = await submitCurrentQuestion();
      setSubmission(newSubmission);
      const currentIndex = newSubmission.knowledgeSubmissionQuestions.findIndex(i => i.id === currentQuestion.id) || 0;
      const next = newSubmission.knowledgeSubmissionQuestions[currentIndex + 1];
      if (next) setCurrentQuestion(next);
    } catch (e) {
      message.error(e.message);
    }
  }

  async function preQuestion() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    try {
      const newSubmission = await submitCurrentQuestion();
      setSubmission(newSubmission);
      const currentIndex = newSubmission.knowledgeSubmissionQuestions.findIndex(i => i.id === currentQuestion.id) || 0;
      const pre = newSubmission.knowledgeSubmissionQuestions[currentIndex - 1];
      if (pre) setCurrentQuestion(pre);
    } catch (e) {
      message.error(e.message);
    }
  }

  async function showAll() {
    if (!currentQuestion) throw new Error('currentQuestion not found');
    try {
      const newSubmission = await submitCurrentQuestion();
      setSubmission(newSubmission);
      setIsShowAll(true);
    } catch (e) {
      message.error(e.message);
    }
  }

  async function submit() {
    submitState
      .request({
        id: submissionId,
      })
      .then(res => {
        if (res.test.type === KnowledgeTestType.正式答题) {
          confirm({
            title: '交卷成功！',
            content: '请在考试时间结束后查看得分和排名！',
            onOk() {
              quickRouter.contestDetail(res.test.contest.id);
            },
            cancelText: false,
          });
        } else {
          quickRouter.knowledgeSubmissionResult(res.id);
        }
      });
  }

  async function autoSubmit() {
    submitState
      .request({
        id: submissionId,
      })
      .then(res => {
        confirm({
          title: '时间到',
          content: '答题时间已到，已自动交卷',
          onOk() {
            if (res.test.type === KnowledgeTestType.正式答题) {
              quickRouter.contestDetail(res.test.contestId);
            } else {
              quickRouter.knowledgeSubmissionResult(res.id);
            }
          },
          cancelText: false,
        });
      });
  }

  useEffect(() => {
    refresh();
  }, [auth.currentUser]);

  function renderQuestionBtn(question: IKnowledgeSubmissionQuestion) {
    return (
      <Col span={3} key={question.id}>
        <Tag
          onClick={() => {
            setCurrentQuestion(question);
            setIsShowAll(false);
          }}
          color={question.choices.length === 0 ? 'orange' : undefined}
          style={{width: 55, marginBottom: 5, textAlign: 'center', cursor: 'pointer'}}>
          第{question.index}题
        </Tag>
      </Col>
    );
  }

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        {submission && (
          <Card
            style={{width: 700}}
            title={
              <Space>
                <Text>剩余时间: </Text>
                <Countdown value={submission.endTime} onFinish={autoSubmit} />
              </Space>
            }
            extra={
              <Space>
                <Button type={'primary'} onClick={showAll}>
                  提交试卷
                </Button>
              </Space>
            }>
            <Flex direction={'column'} align={'center'}>
              <Title level={5}>{submission.test.contest.name}</Title>
              <Title level={3} style={{marginBottom: 0, marginTop: 0}}>
                {KnowledgeTestType[submission.test.type]}
              </Title>
              {currentQuestion && <KnowledgeQuestionSubmitItem question={currentQuestion} onChange={setCurrentQuestion} />}
              <Divider />
              <Space>
                <Button onClick={preQuestion} disabled={questions.findIndex(i => i.id === currentQuestion?.id) === 0}>
                  上一题
                </Button>
                <Button onClick={showAll}>查看所有题目</Button>
                <Button onClick={nextQuestion} disabled={questions.findIndex(i => i.id === currentQuestion?.id) === questions.length - 1}>
                  下一题
                </Button>
              </Space>
            </Flex>
            <Modal visible={isShowAll} onCancel={() => setIsShowAll(false)} footer={false}>
              <div style={{textAlign: 'center'}}>
                <h3>单选题</h3>
                <Row>{questions.filter(q => q.type === KnowledgeQuestionType.单选题).map(q => renderQuestionBtn(q))}</Row>
                <h3 style={{marginTop: 20}}>多选题</h3>
                <Row>{questions.filter(q => q.type === KnowledgeQuestionType.多选题).map(q => renderQuestionBtn(q))}</Row>
                <Divider />
                <div>黄色背景为未答试题</div>
                <div className={'mb-md'}>点击对应序号继续答题或提交试卷</div>
                <Space>
                  <Button onClick={() => setIsShowAll(false)}>继续答题</Button>
                  <Button loading={submitState.loading} onClick={submit} type={'primary'}>
                    提交试卷
                  </Button>
                </Space>
              </div>
            </Modal>
          </Card>
        )}
      </div>
    </Flex>
  );
}
